"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var HeMultiselect_vue_1 = __importDefault(require("./HeMultiselect.vue"));
vue_1.default.component("he-multi-select", HeMultiselect_vue_1.default);
exports.default = HeMultiselect_vue_1.default;
//$(() => {
//   $(".szp-multi-select-inject").each((index, element) => {
//       var $me = $(element);
//       
//       let vm = new HeMultiSelect({
//           el: element,
//           propsData: {
//               
//           }
//       }) as Vue;
//       
//       
//   })
//});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/SharedComponent/HeMultiselect/index.ts
// module id = 617
// module chunks = 0